Controller = App.loadClass 'core::Angular/Controller'

class exports.PlacementController extends Controller
    constructor: (@scope, @transitions, @state, @location, @timeout) ->
        $('.leaflet-control-buttongrid').show()
        # Instance Data
        @scope.repo = @location
        @scope.tool_active = true

        # Function Declarations
        @scope.transitionTo = @transitionTo

        if @location.new.id
            @location.marker_placed = true
            # @location.new = @location.existing
            @loadMarker()

        # Redirect if we skipped the starting state
        if not @location.new?
            @state.go '^'
            return

        # Add the control back to the map
        App.map.addControl(@location.drawControl) if not @location.drawControl?._map

        # Show marker tool
        $('.leaflet-control-container').show()
        @location.drawControl.select()

        # Listener for marker placment
        App.map.on 'draw:created', @draw

        # Listener for marker tool selection
        @location.drawControl.on 'mfmarker:tool_selected', (e) =>
            @scope.tool_active = true
            @scope.$apply()

        # Transition Hooks
        # Disable the tool and hide controls; cleanup map if leaving process
        @transitionStart = @transitions.onStart {}, ($transition) =>
            if $transition.to().name isnt 'grower.buyerlocation.locate' and
            $transition.to().name isnt 'grower.buyerlocation.identify'
                App.map.removeLayer(@location.feature_group) if @location.feature_group?
                App.map.removeControl(@location.drawControl) if @location.drawControl?._map
                # show the drawing controls container since we're leaving the process
                # $('.leaflet-control-container').show()

            # always deselect drawing control
            @location.drawControl.deselect()
            # remove the hook
            App.map.off 'draw:created', @draw

        @scope.$on '$destroy', () =>
            @transitionStart()


    loadMarker: () =>
        return if Object.keys(@location.feature_group._layers).length > 0

        # Load the marker and add it to the map
        marker = L.marker([@location.new.latitude, @location.new.longitude], { icon: @location.icon })
        @location.feature_group.addLayer(marker)

        # Use fitBounds() to zoom/pan the map to our marker
        App.map.fitBounds @location.feature_group.getBounds()


    draw: (e) =>
        lat = e.layer._latlng.lat
        long = e.layer._latlng.lng

        # Check to see if the location was placed in an area we have GIS data for
        @location.checkPlacement(lat, long).then (response) =>
            # Don't allow the creation if we don't have data...
            if response.data.status.type is 'error'
                @showErrorPopup(response.data.status.msg, lat, long)
                # Reselecting the marker tool has to be wrapped in a timeout in order to prevent digest errors.
                @timeout () =>
                    @location.drawControl.select()
                , 500
                return

            # ...or continue on if we do
            # Remove any existing marker and update the flag if placing a fresh one
            if @location.marker_placed
                @location.feature_group.eachLayer((layer) =>
                    @location.feature_group.removeLayer(layer)
                )
            else
                @location.marker_placed = true
            # Set custom icon and add the newly placed marker to the map
            e.layer.options.icon = @location.icon
            @location.feature_group.addLayer(e.layer)
            # Update the location object with the lat/long
            @location.new.latitude = lat
            @location.new.longitude = long
            @location.new.zip = response.data.data.zip
            @location.new.admin_area_2_id = response.data.data.admin_area_2_id

            @scope.tool_active = false


    transitionTo: (state_name) =>
        @state.go state_name


    showErrorPopup: (error_msg, lat, long) =>
        # Add the error popup to the map
        L.popup({ closeButton: false, className: 'storagePopup' })
            .setLatLng(L.latLng(lat, long))
            .setContent(error_msg)
            .openOn(App.map)

        # Close it after 3 seconds. Sucks there's no API method for this :(
        @timeout () =>
            App.map.closePopup()
        , 3000
